﻿import { onEvent } from "./_dom";

const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";

function encodeInt32(n) {
	var s = "";
	n = n >>> 0;
	var bits = 5;
	var msb = Math.pow(2, bits);
	var mask = msb - 1;
	do {
		var x = n & mask;
		n >>>= bits;
		if (n) x |= msb;
		s += alphabet[x];
	} while (n);
	return s;
}

function encodeIdArray(arr, id, maxLength, forwardOnly) {
	var pos = arr.indexOf(id << 1);
	if (pos < 0)
		pos = arr.indexOf((id << 1) | 1);
	var s;
	var seqPrev = [];
	var seqNext = [];
	var maxD = arr.length - pos;
	if (!forwardOnly && pos > maxD)
		maxD = pos;
	for (var i = 0; i < maxD; i++) {
		var pn = pos + i;
		var pp = pos - 1 - i;
		if (pn < arr.length) {
			s = encodeInt32(arr[pn]);
			if (s.length < maxLength) {
				seqNext.push(s);
				maxLength -= s.length;
			} else {
				break;
			}
		}
		if (!forwardOnly && pp >= 0) {
			s = encodeInt32(arr[pp]);
			if (s.length < maxLength) {
				seqPrev.unshift(s);
				maxLength -= s.length;
			} else {
				break;
			}
		}
	}
	return seqPrev.concat(seqNext).join("");
}

function buildSeq(view, selector) {
	var seq = [];
	view.querySelectorAll(selector).forEach(el => {
		var href = el.getAttribute("href");
		var n = href.indexOf("?");
		if (n >= 0) {
			var qs = new URLSearchParams(href.substring(n));
			var id = qs.get("id") >>> 0;
			if (!id) return;
			seq.push(id);
		}
	});
	return seq;
}

function buildViewEditSeq(view, viewSelector, editSelector) {
	function clear0(v) { return v << 1; }
	function set0(v) { return (v << 1) | 1; }
	function check0(v) { return (v << 1) | (editSeq.indexOf(v) >= 0 ? 1 : 0); }

	var viewSeq = buildSeq(view, viewSelector);
	var editSeq = [];
	var editable;
	if (viewSelector === editSelector) {
		editSeq = viewSeq;
		editable = true;
	} else if (!editSelector) {
		editSeq = null;
	} else {
		editSeq = buildSeq(view, editSelector);
		if (!viewSeq.length) {
			viewSeq = editSeq;
			editable = true;
		} else if (!editSeq.length) {
			editable = false;
		}
	}

	return viewSeq.map(editable === true ? set0 : editable === false ? clear0 : check0, editSeq);
}

function handleClick(view, element, viewSelector, editSelector) {
	var fromEdit = editSelector === viewSelector;
	var href = element.getAttribute("href");
	var maxLength = 16384 - 4 - 10 - href.length; // max length - max id length - "seq=";
	var n = href.indexOf("?");
	if (n >= 0) {
		var qs = new URLSearchParams(href.substring(n));
		var seqArr = buildViewEditSeq(view, viewSelector, editSelector, fromEdit);
		var id = +qs.get("id");
		var seq = encodeIdArray(seqArr, id, maxLength);
		qs.set("seq", seq);
		element.setAttribute("href", href.substring(0, n + 1) + qs.toString());
	}
}

function prevNextClickHandler(event) {
	const btn = event.target.closest("a.ui-action-view");
	if (btn != null) {
		handleClick(this, btn, "a.ui-action-view", "a.ui-action-edit");
	}
}

function saveNextClickHandler(event) {
	const btn = event.target.closest("a.ui-action-edit");
	if (btn != null) {
		handleClick(this, btn, "a.ui-action-edit", "a.ui-action-edit");
	}
}

function init(ctx) {
	onEvent(ctx, ".js-prevnext", "click", prevNextClickHandler);
	onEvent(ctx, ".js-savenext", "click", saveNextClickHandler);
}

export { init };
